module.exports = __webpack_public_path__ + "img/collection-engagementRingsGold@2x.49dc316.jpg";